import { questionPresentationContent } from "../../data/QuestionPresentation";

export const isRadioQuestion = (question) =>
  question.answers.length === 2 &&
  question.answers[0].label === "Yes" &&
  question.answers[1].label === "No";

export const validateCheckboxAnswers = (state) => {
  const questionKeys = Object.keys(state);
  return questionKeys.every((key) => {
    return (
      state[key][0] !==
        questionPresentationContent[key]?.component?.content
          ?.showCheckboxValue && state[key].length > 0
    );
  });
};

export const getInitialCheckboxState = (
  checkboxQuestionIds,
  currentAnswers
) => {
  const initialState = {};
  checkboxQuestionIds.forEach((id) => {
    if (currentAnswers[id]) {
      initialState[id] = currentAnswers[id];
    }
  });
  return initialState;
};
